export const ESI_PATIENTS_LIST = 'esi-patients-list';
export const ESI_PATIENTS_LIST_RESULT = ESI_PATIENTS_LIST + '/result';
export const ESI_PATIENTS_LIST_ERROR = ESI_PATIENTS_LIST + '/error';

export const ESI_PATIENTS_LIST_CLEAR = 'esi-patients-list-clear';
export const ESI_PATIENT_GET_CLEAR = 'esi-patient-info-clear';
export const ESI_PATIENTS_TIMESTAMP_CLEAR = 'esi-patient-timestamp-clear';
